import {
  backgroundColorCss,
  borderCss,
  colorCss,
  fontSizeCss,
  mobileBackgroundColorCss,
  mobileBorderCss,
  mobileColorCss,
  mobileFontSizeCss,
} from 'common/utils/styleUtilsNew'
import { CouponButtonInterface } from 'src/shared/entities/coupon/coupon.schema'
import styled, { css } from 'styled-components'

interface CouponButtonUiProps extends Omit<CouponButtonInterface, 'text'> {
  checking?: boolean
}

const CouponButtonUi = styled.button<CouponButtonUiProps>`
  padding: 5px 8px;
  outline: none;
  transition: opacity 0.2s ease;
  cursor: pointer;
  opacity: ${p => (p.checking ? 0.5 : 1)};

  ${fontSizeCss}
  ${colorCss}
  ${backgroundColorCss}
  ${borderCss}
    
  ${p => p.theme.phone} {
    width: 100%;
    ${mobileFontSizeCss}
    ${mobileColorCss}
    ${mobileBackgroundColorCss}
    ${mobileBorderCss}
  }

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
    width: 100%;
    ${mobileFontSizeCss}
    ${mobileColorCss}
    ${mobileBackgroundColorCss}
    ${mobileBorderCss}
  `}
`

export default CouponButtonUi
